module.exports = __webpack_public_path__ + "media/images/admin/icons/cast-44e78bd224714fb20d0fa04c38974aa7.svg";